var _path, _rect, _rect2, _path2, _path3, _path4, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCleaningServiceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 98,
    viewBox: "0 0 100 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1056 56.2625V12.842C17.1056 8.89465 19.474 1 28.9476 1C38.4211 1 49.5614 1 53.9473 1C57.8946 1 65.7893 3.36839 65.7893 12.842C65.7893 22.3155 65.7893 37.8417 65.7893 44.4206",
    stroke: "#09B162",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.527,
    y: 49.6842,
    width: 13.1577,
    height: 44.7363,
    rx: 2,
    fill: "#FFC200"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60.526,
    y: 15.473,
    width: 10.5262,
    height: 13.1577,
    fill: "#09B162"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.0261C0 87.6454 1.11929 86.5261 2.5 86.5261H31.7101C33.0908 86.5261 34.2101 87.6454 34.2101 89.0261V97.0523H0V89.0261Z",
    fill: "#09B162"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2637 28C55.2637 26.8954 56.1591 26 57.2637 26H91.5C96.1944 26 100 29.8056 100 34.5V93.0518C100 95.261 98.2092 97.0518 96 97.0518H58.2637C56.6068 97.0518 55.2637 95.7087 55.2637 94.0518V28Z",
    fill: "#FFC200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0518 26H91.4989C96.1933 26 99.9989 29.8056 99.9989 34.5V93.0518C99.9989 95.261 98.208 97.0518 95.9989 97.0518H71.0518V26Z",
    fill: "#09B162"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.8417,
    cy: 82.5782,
    r: 14.4735,
    fill: "#30334F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.8409,
    cy: 82.5788,
    r: 9.21043,
    fill: "#9BDFBF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaningServiceIcon);
export default __webpack_public_path__ + "static/media/cleaning_service_icon.7898c0380cc6498d719dcc9b55cc5a6c.svg";
export { ForwardRef as ReactComponent };